import type { components } from "@/api/types";

export type ProfileResponse = components["schemas"]["ProfileResponse"];
export type ProfileStats = components["schemas"]["ProfileStats"];
export type ReferralResponse = components["schemas"]["ReferralResponse"];
export type LegalDocument = components["schemas"]["LegalDocument"];

/**
 * Правовые документы. Бэкенд обслуживает ровно три слага и на любой другой
 * отвечает 404, поэтому список экрана строится из этого белого списка, а не
 * из шести строк макета (DESIGN.md §2.5).
 */
export const LEGAL_SLUGS = ["terms", "privacy", "risk-disclosure"] as const;

export type LegalSlug = (typeof LEGAL_SLUGS)[number];
